import {NgModule} from '@angular/core';
import {InvPortfolioService} from './inv-portfolio.service';

@NgModule({
    providers: [
        InvPortfolioService
    ]
})
export class InvPortfolioModule {}
